// extracted by mini-css-extract-plugin
module.exports = {"loader":"auth_loader__1ZdID"};